import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DbEventsProvider } from 'src/app/providers/database/db.events';
import { DbAnalyticsProvider } from 'src/app/providers/database/db-analytics';
import { GlobalService } from 'src/app/providers/global/global.service';
import { FormatedEventLanguageService } from 'src/app/providers/formated-event-language/formated-event-language.service';
import { AppState } from 'src/app/shared/reducers';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { getDocumentsAnalytics } from 'src/app/shared/selectors/analytics.selectors';

@Component({
    selector: 'app-documents-analytics',
    templateUrl: './documents-analytics.component.html',
    styleUrls: ['./documents-analytics.component.scss']
})
export class DocumentsAnalyticsComponent implements OnInit {
    loader: boolean = true;

    event: any;
    eventId: string;
    userLanguage: string;

    bestDocuments: any[] = [];
    totalDocuments: number = 0;

    constructor(
        private route: ActivatedRoute,
        private dbEvent: DbEventsProvider,
        private dbAnalytics: DbAnalyticsProvider,
        private global: GlobalService,
        public formatedLanguage: FormatedEventLanguageService,
        private store: Store<AppState>
    ) { }

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.eventId = params.uid;
            this.getUserLanguage()
            this.getEvent();
        })
    }

    getUserLanguage() {
        this.global.getLanguage((language) => {
            this.userLanguage = this.formatedLanguage.convertLang(language);
        })
    }

    getEvent() {
        this.dbEvent.getEvent(this.eventId, (event) => {
            this.event = event;
            this.formatedLanguage.convertLangFormat(event.language);
            this.dbAnalytics.getDocumentsAnalytics(this.eventId).pipe(take(1)).subscribe(() => {
                this.store.select(getDocumentsAnalytics).subscribe((documentsAnalytics) => {
                    this.bestDocuments = (documentsAnalytics && documentsAnalytics.bestDocuments) ? documentsAnalytics.bestDocuments : [];
                    this.totalDocuments = (documentsAnalytics && documentsAnalytics.totalDocuments) ? documentsAnalytics.totalDocuments : 0;

                    this.loader = false;
                })
            });
        });
    }

    /**
     * Export documents analytics
     */
    exportAll() {
        this.loader = true;
        this.dbAnalytics.exportDocumentsAnalytics(this.eventId, this.userLanguage).subscribe((result) => {
            this.loader = false;
        }, (error) => {
            console.log("Error: ", error);
            this.loader = false;
        })
    }
}
